<form
  noValidate
  ngNoForm
  [action]="config.resetPassword.action"
  [method]="config.resetPassword.method"
>
  <p class="title">Forgot Password</p>

  <div class="description">
    Enter your email address below and we will send you a link to reset your password.
  </div>

  <mat-form-field appearance="outline" hideRequiredMarker>
    <mat-label>Email</mat-label>
    <input
      matInput
      [formControl]="emailControl"
      type="email"
      name="email"
      required
      spellcheck="false"
    />
  </mat-form-field>

  <button
    mat-raised-button
    color="primary"
    type="submit"
    [disabled]="emailControl.invalid"
    [style.filter]="this.colorAnimation.hueRotate$ | async"
  >
    Reset Password
  </button>

  <a class="login-link" routerLink="/login.html">Back to Login </a>
</form>
